import { CurrencyDto } from '../../domain/models/dto/currency.dto';

export const Moedas: CurrencyDto[] = [
  {
    id: 1,
    value: 'USD',
    description: 'Dólar americano (USD)',
    image: 'assets/flags/usd.svg',
    icon: 'usd',
    selected: false,
  },
  {
    id: 2,
    value: 'EUR',
    description: 'Euro (EUR)',
    image: 'assets/flags/eur.svg',
    icon: 'eur',
    selected: false,
  },
  {
    id: 3,
    value: 'GBP',
    description: 'Libra esterlina (GBP)',
    image: 'assets/flags/gbp.svg',
    icon: 'gbp',
    selected: false,
  },
  {
    id: 4,
    value: 'CHF',
    description: 'Franco suíço (CHF)',
    image: 'assets/flags/chf.svg',
    icon: 'chf',
    selected: false,
  },
  {
    id: 5,
    value: 'AUD',
    description: 'Dólar australiano (AUD)',
    image: 'assets/flags/aud.svg',
    icon: 'aud',
    selected: false,
  },
  {
    id: 6,
    value: 'CAD',
    description: 'Dólar canadense (CAD)',
    image: 'assets/flags/cad.svg',
    icon: 'cad',
    selected: false,
  },
  {
    id: 7,
    value: 'NZD',
    description: 'Dólar neozelandês (NZD)',
    image: 'assets/flags/nzd.svg',
    icon: 'nzd',
    selected: false,
  },
  {
    id: 8,
    value: 'JPY',
    description: 'Iene japonês (JPY)',
    image: 'assets/flags/jpy.svg',
    icon: 'jpy',
    selected: false,
  },
  {
    id: 9,
    value: 'ZAR',
    description: 'Rand sul-africano (ZAR)',
    image: 'assets/flags/zar.svg',
    icon: 'zar',
    selected: false,
  },
  {
    id: 10,
    value: 'DKK',
    description: 'Coroa dinamarquesa (DKK)',
    image: 'assets/flags/dkk.svg',
    icon: 'dkk',
    selected: false,
  },
  {
    id: 11,
    value: 'NOK',
    description: 'Coroa norueguesa (NOK)',
    image: 'assets/flags/nok.svg',
    icon: 'nok',
    selected: false,
  },
  {
    id: 12,
    value: 'SEK',
    description: 'Coroa sueca (SEK)',
    image: 'assets/flags/sek.svg',
    icon: 'sek',
    selected: false,
  },
  {
    id: 13,
    value: 'MXN',
    description: 'Peso mexicano (MXN)',
    image: 'assets/flags/mxn.svg',
    icon: 'mxn',
    selected: false,
  }
];

export const MoedasInbound: CurrencyDto[] = [
  {
    id: 1,
    value: 'USD',
    description: 'Dólar americano (USD)',
    image: 'assets/flags/usd.svg',
    icon: 'usd',
    selected: false,
  },
  {
    id: 2,
    value: 'EUR',
    description: 'Euro (EUR)',
    image: 'assets/flags/eur.svg',
    icon: 'eur',
    selected: false,
  },
  {
    id: 3,
    value: 'GBP',
    description: 'Libra esterlina (GBP)',
    image: 'assets/flags/gbp.svg',
    icon: 'gbp',
    selected: false,
  },
  {
    id: 4,
    value: 'CHF',
    description: 'Franco suíço (CHF)',
    image: 'assets/flags/chf.svg',
    icon: 'chf',
    selected: false,
  },
  {
    id: 6,
    value: 'CAD',
    description: 'Dólar canadense (CAD)',
    image: 'assets/flags/cad.svg',
    icon: 'cad',
    selected: false,
  },
  {
    id: 8,
    value: 'JPY',
    description: 'Iene japonês (JPY)',
    image: 'assets/flags/jpy.svg',
    icon: 'jpy',
    selected: false,
  }
];
